import React from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import FileFolderBuilder, { IFileWithPath } from './FileFolderBuilder';
import FileFolder from './FileFolder';
import { maxBytesPerUpload } from '../../common/constants';

// const fileTooLargeCode = 'file-too-large';

interface IFileDropzoneProps {
  onDropStart?: () => void;
  onDropEnd?: () => void;
  onDrop: (fileFolder: FileFolder) => void | Promise<void>;
  openOnClick?: boolean;
  onUploadTooLarge?: () => void;
  multiple?: boolean;
  className?: string;
}

const FileDropzone: React.FC<IFileDropzoneProps> = (props) => {
  const onDrop = <T extends File & { path?: string }>(acceptedFiles: T[], rejections: FileRejection[]) => {
    if (!acceptedFiles.every((file) => typeof file.path === 'string')) {
      // TODO: error
      return;
    }

    if (rejections.length > 0) {
      if (props.onUploadTooLarge) {
        props.onUploadTooLarge();
      }
    } else if (acceptedFiles.length > 0) {
      const folderStructure = FileFolderBuilder.from(acceptedFiles as IFileWithPath[]);
      if (folderStructure.totalSize() > maxBytesPerUpload) {
        if (props.onUploadTooLarge) {
          props.onUploadTooLarge();
        }
      } else {
        if (props.onDropStart) props.onDropStart();
        props.onDrop(folderStructure);
      }
    }
  };

  const { getRootProps, getInputProps, isDragActive, isDragAccept } = useDropzone({
    noClick: !props.openOnClick,
    noKeyboard: true,
    noDragEventsBubbling: true,
    onDrop,
    maxSize: maxBytesPerUpload,
    onError: (err) => {
      console.error(err)
      if (props.onDropEnd) props.onDropEnd();
    },
    multiple: props.multiple === undefined ? true : props.multiple,
    onFileDialogCancel: () => {
      if (props.onDropEnd) props.onDropEnd();       
    },
    onFileDialogOpen: () => {
      if (props.onDropStart) props.onDropStart();
    },

/*     onDropRejected(fileRejections, event) {
      const tooLarge = fileRejections
        .filter((reject) => reject.errors.some((error) => error.code === fileTooLargeCode))
        .map((reject) => reject.file)
        .map((f: File & { path?: string }) => f.name);
      if (props.onUploadTooLarge) {
        props.onUploadTooLarge();
      }
    }, */
  });

  return (
      <div
          {...getRootProps({
            className: `dropzone full-height ${isDragActive && 'dropzone-drag-active'} ${
                isDragAccept && 'dropzone-drag-accept'
            } ${props.className ? props.className : ''}`,
          })}
      >
        <input {...getInputProps()} />
        {props.children}
      </div>
  );
};

export default FileDropzone;
